jQuery(document).ready(function($) {
  var $hamburger    = $('.hamburger');
  var $hamburgerOpen = $('.hamburger').not('.hamburger--close');
  var $hamburgerClose = $('.hamburger--close');
  var $drawerMenu   = $('.b-drawer-menu');
  var $header       = $('.b-header');

  // Sticky header — scroll-driven so it works with any top offset (incl. admin bar)
  if ($('body:not(.wp-admin)').length > 0) {
    const el = document.querySelector('.b-header');
    if (el) {
      function updateSticky() {
        el.classList.toggle('is-stuck', window.scrollY > 1);
      }
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
    }
  }

  // Sync CSS custom properties for header height and editor width
  function setHeaderHeight() {
    var h  = Math.floor($header.outerHeight());
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }

  function setEditorWidth() {
    var w = Math.ceil($('.is-root-container').outerWidth());
    document.documentElement.style.setProperty('--editor-w', w + 'px');
  }

  setEditorWidth();
  $(window).on('resize load', setEditorWidth);
  if (window.wp && wp.domReady) {
    wp.domReady(setEditorWidth);
  }

  setHeaderHeight();
  $(window).on('resize', setHeaderHeight);

  function toggleDrawer(open) {
    $drawerMenu.toggleClass('open', open);
    $hamburgerOpen.toggleClass('open', open);
    $header.toggleClass('menu-open', open);
    var isOpen = $drawerMenu.hasClass('open');
    $hamburgerOpen.attr('aria-expanded', isOpen);
    $hamburgerClose.attr('aria-expanded', isOpen);
    $drawerMenu.attr('aria-hidden', !isOpen);
    $('body').css('overflow', isOpen ? 'hidden' : '');
  }

  // Mobile hamburger
  $hamburgerOpen.on('click', function() {
    toggleDrawer(!$drawerMenu.hasClass('open'));
  });
  $hamburgerClose.on('click', function() {
    toggleDrawer(false);
  });

  // Sub-nav toggles
  function slideToggleSubNav(menuToggle) {
    var isExpanded = $(menuToggle).attr('aria-expanded') === 'true';
    $(menuToggle).attr('aria-expanded', !isExpanded);
    $(menuToggle).toggleClass('active');
    $(menuToggle).next().slideToggle();
  }

  $('.menu-toggle', $('.b-header__menu__primary-menu')).on('click', function() {
    slideToggleSubNav(this);
  });

  $('.menu-toggle', $('.b-drawer-menu')).on('click', function() {
    slideToggleSubNav(this);
  });

  $('.b-drawer-menu a').on('click', function() {
    if (!$(this).closest('.nav-main-item').length || !$(this).siblings('.nav-drop').length) {
      toggleDrawer(false);
    }
  });

  var $firstToggle = $('.b-drawer-menu .menu-toggle').first();
  if ($firstToggle.length) {
    $firstToggle.attr('aria-expanded', true).addClass('active');
    $firstToggle.next('.nav-drop').show();
  }

  // Desktop nav — tabs-style dropdown switching
  $('.nav-drop--tabs').each(function() {
    var $tabsDrop = $(this);
    $tabsDrop.on('click', '[data-tab-btn]', function() {
      var index = $(this).data('tab-btn');
      $tabsDrop.find('[data-tab-btn]').removeClass('is-active').attr('aria-selected', 'false');
      $(this).addClass('is-active').attr('aria-selected', 'true');
      $tabsDrop.find('[data-tab-panel]').removeClass('is-active');
      $tabsDrop.find('[data-tab-panel="' + index + '"]').addClass('is-active');
    });
  });

  // Reset a desktop dropdown's tab back to the first one once the menu closes
  $('.nav-main-item--tabs').on('mouseleave', function() {
    var $tabsDrop = $(this).find('.nav-drop--tabs');
    $tabsDrop.find('[data-tab-btn]').removeClass('is-active').attr('aria-selected', 'false').first().addClass('is-active').attr('aria-selected', 'true');
    $tabsDrop.find('[data-tab-panel]').removeClass('is-active').first().addClass('is-active');
  });

  // Resources filter dropdowns
  var $filterDropdowns = $('[data-filter-dropdown]');
  var $filterForm      = $('[data-filter-form]');

  $filterDropdowns.find('.b-resources-filter__cat-btn').on('click', function() {
    var $wrap = $(this).closest('[data-filter-dropdown]');
    var isOpen = $wrap.hasClass('is-open');
    $filterDropdowns.removeClass('is-open').find('.b-resources-filter__cat-btn').attr('aria-expanded', false);
    if (!isOpen) {
      $wrap.addClass('is-open');
      $(this).attr('aria-expanded', true);
    }
  });

  $(document).on('click', function(e) {
    if (!$(e.target).closest('[data-filter-dropdown]').length) {
      $filterDropdowns.removeClass('is-open').find('.b-resources-filter__cat-btn').attr('aria-expanded', false);
    }
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      $filterDropdowns.removeClass('is-open').find('.b-resources-filter__cat-btn').attr('aria-expanded', false);
    }
  });

  // Checking/unchecking a term submits the filter form immediately.
  $filterForm.on('change', '[data-filter-checkbox]', function() {
    $filterForm[0].submit();
  });

  // Remove a single selected token by unchecking its checkbox, then resubmit.
  $filterForm.on('click', '[data-filter-token]', function() {
    var $token = $(this);
    var param  = $token.data('param');
    var value  = $token.data('value');
    $filterForm.find('input[name="' + param + '[]"][value="' + value + '"]').prop('checked', false);
    $filterForm[0].submit();
  });

  // Clear every selected term and resubmit.
  $filterForm.on('click', '[data-filter-clear]', function() {
    $filterForm.find('[data-filter-checkbox]').prop('checked', false);
    $filterForm[0].submit();
  });

});
